import defaultForm from './default-form';

export default {
    defaultForm,
};
